module.exports = __webpack_public_path__ + "img/IDS_Logo.23910833.png";